import type { ColumnsType } from "antd/es/table";
import { langCommon, langPage, langTableColumns } from "../../../locales";
import { floatNumberInThousands } from "../../../utils/tools"
import { FormConfigType } from "../../../components/editForm";
import dayjs from 'dayjs';

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.balanceLog;


export const DEFAULT_QUERY_DATA = {
    Email: null,
    Status: null,
    TransferType: null,
}

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { options: { statusOptions, transferTypeOptions } } = props;

    return [
        {
            title: langRecharge?.email,
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            allowClear: true,
            options: statusOptions,
        },
        {
            title: "交易类型",
            type: "select",
            field: "TransferType",
            allowClear: true,
            options: transferTypeOptions,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {

    return [
        {
            title: "ID",
            dataIndex: "Id",
        },
        {
            title: "用户id",
            dataIndex: "MemberId",
        },
        {
            title: "用户邮箱",
            dataIndex: "Email",
            render(value, record, index) {
                return value || record.Member?.Email
            },
        },
        {
            title: "交易金额", 
            dataIndex: "Amount",
        },
        {
            title: "交易份额", 
            dataIndex: "Shares",
        },
        {
            title: "交易类型", 
            dataIndex: "TransferTypeString",
        },
        {
            title: "状态", 
            dataIndex: "StatusString",
        },
        {
            title: "份额确认日期", 
            dataIndex: "EffectiveDateString",
        },
        {
            title: "份额确认完成时间", 
            dataIndex: "CompletedAtString",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
    ]
}
